import { Typography } from 'antd';
import React from 'react';
import styles from './App.module.scss';
const { Title } = Typography;

const MovieCredits = props => {
  function renderCast(credits) {
    return credits.map(cast => {
      return (
        <li key={cast.id}>
          <img
            src={`https://image.tmdb.org/t/p/w185//${cast.profile_path}`}
            className={styles.borderline}
            alt="Movie Cast"
          />
          <div>
            <div>
              <Title level={4} strong>
                {cast.name}
              </Title>
              <Title level={4} strong className={styles.margin_bottom_wide}>
                {cast.character}
              </Title>
            </div>
          </div>
        </li>
      );
    });
  }
  return (
    <ul className={styles.overflow_hidden}>{renderCast(props.credits)}</ul>
  );
};

export default MovieCredits;
